import { useEffect, useState } from 'react';
import { isInstalledPWA } from './is-pwa';

export function useIsPwa(): boolean {
  const [isPwa, setIsPwa] = useState(() => isInstalledPWA());

  useEffect(() => {
    const mq = window.matchMedia('(display-mode: standalone)');
    const handler = (e: MediaQueryListEvent) => setIsPwa(e.matches || isInstalledPWA());
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isPwa;
}
